<template>
  <div class="page-content free-study-page">
    <div class="content-wrap" v-loading="pageLoading">
        <div class="mianbao mt2">
          <span class="dq">当前位置：</span>
          <a href="javascript:void(0);" @click="$router.push('/main/home')" class="mba">个人中心</a> &gt;
          <a href="javascript:void(0);" @click="$router.push('/main/specialtyPlan')" class="mba">专业计划</a> &gt;
          <a href="javascript:void(0);" @click="$router.back()" class="mba">自由学习</a> &gt;
          <span class="site">练习记录</span>
        </div>

        <div class="paper-summary">
          <div class="summary-top">
            <div>
              <p class="paper-name">{{ paperInfo.name }}</p>
              <p class="paper-meta">
                <span>课程：{{ paperInfo.courseFullName }}</span>
                <span>题量：{{ paperInfo.totalCount }}题</span>
              </p>
            </div>
            <a href="javascript:void(0);" class="redo-btn" @click="goRedo">重新练习</a>
          </div>
          <div class="summary-stats">
            <div class="stat-item">
              <div class="stat-num">{{ summaryData.practiceCount }}</div>
              <div class="stat-label">练习次数</div>
            </div>
            <div class="stat-item">
              <div class="stat-num success">{{ summaryData.correctRate }}%</div>
              <div class="stat-label">客观题正确率</div>
              <div class="stat-trend" :class="summaryData.rateTrend >= 0 ? 'up' : 'down'" v-if="summaryData.rateTrend !== undefined">
                {{ summaryData.rateTrend >= 0 ? '↑' : '↓' }} 较上次 {{ summaryData.rateTrend >= 0 ? '+' : '' }}{{ summaryData.rateTrend }}%
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-num warning">{{ summaryData.avgCorrectRate }}%</div>
              <div class="stat-label">客观题平均正确率</div>
            </div>
            <div class="stat-item clickable" @click="openWrongModal">
              <div class="stat-num danger">{{ summaryData.wrongCount }}</div>
              <div class="stat-label">错题集</div>
            </div>
            <div class="stat-item clickable" @click="openFavModal">
              <div class="stat-num success">{{ summaryData.favCount }}</div>
              <div class="stat-label">收藏夹</div>
            </div>
          </div>
        </div>

        <div class="trend-card">
          <p class="card-title">正确率趋势<span class="sub">（客观题）</span></p>
          <div class="trend-chart">
            <div
              class="trend-bar-wrap"
              :class="{ best: item.isBest }"
              v-for="(item, idx) in trendList"
              :key="idx"
            >
              <div class="trend-bar" :style="{ height: normalizedHeight(item.rate) + 'px' }">
                <span class="bar-tooltip">{{ item.rate }}%</span>
              </div>
              <span class="trend-bar-label">{{ item.label }}</span>
            </div>
          </div>
          <div class="trend-legend">
            <span><span class="dot best"></span> 历史最佳</span>
            <span><span class="dot normal"></span> 正常水平</span>
          </div>
        </div>

        <div class="record-list-card">
          <div class="record-list-header">
            <p class="title">练习记录</p>
            <p class="subtitle">共{{ recordList.length }}次练习记录，点击可查看答题详情</p>
          </div>
          <div
            class="record-item"
            v-for="(record, idx) in recordList"
            :key="record.id"
            @click="openReview(record)"
          >
            <div class="record-time">
              <div class="time-date">{{ record.date }}</div>
              <div class="time-hour">{{ record.time }}</div>
            </div>
            <div class="record-detail">
              <span>客观题正确率：<span class="val correct">{{ record.correctRate }}%</span></span>
              <span>用时：{{ record.duration }}分钟</span>
              <span>客观题答对：<span class="val correct">{{ record.correctCount }}题</span></span>
              <span>客观题答错：<span class="val wrong">{{ record.wrongCount }}题</span></span>
            </div>
            <div class="record-action">
              <button class="action-btn" @click.stop="openReview(record)">详情</button>
              <button class="action-btn delete" @click.stop="deleteRecord(record, idx)">删除</button>
            </div>
          </div>
          <div class="empty-state" v-if="recordList.length === 0">
            <div class="icon">📋</div>
            <p>暂无练习记录</p>
          </div>
        </div>
    </div>

    <div class="custom-modal-mask" v-if="reviewVisible" @click.self="reviewVisible = false">
      <div class="custom-modal review-dialog" style="width: 1100px;">
        <div class="custom-modal-header">
          <span class="modal-title">练习记录 - {{ reviewRecord.date }} {{ reviewRecord.time }}</span>
          <span class="custom-modal-close" @click="reviewVisible = false">&times;</span>
        </div>
        <div class="custom-modal-body">
          <div class="review-stats">
            <div class="review-stat">
              <div class="stat-value correct">{{ reviewRecord.correctRate }}%</div>
              <div class="stat-label">客观题正确率</div>
            </div>
            <div class="review-stat">
              <div class="stat-value correct">{{ reviewRecord.correctCount }}</div>
              <div class="stat-label">客观题答对</div>
            </div>
            <div class="review-stat">
              <div class="stat-value wrong">{{ reviewRecord.wrongCount }}</div>
              <div class="stat-label">客观题答错</div>
            </div>
            <div class="review-stat">
              <div class="stat-value">{{ reviewRecord.duration }}分钟</div>
              <div class="stat-label">用时</div>
            </div>
          </div>
          <div class="review-questions">
            <div class="review-main">
              <div v-for="(section, si) in reviewSections" :key="si" class="question-card">
                <div class="q-section-title">{{ sectionTitle(section, si) }}</div>
                <div v-for="q in section.questions" :key="q.id" class="q-item" :ref="'reviewQ_' + q.globalIndex">
                  <p class="q-num-tag">{{ q.globalIndex }}. <span v-html="q.content"></span></p>
                  <ul class="q-options" v-if="q.type === 'SINGLECHOICE' || q.type === 'MULTIPLECHOICE' || q.type === 'JUDGMENT'">
                    <template v-if="q.type === 'JUDGMENT'">
                      <li :class="getReviewOptionClass(q, 'Y')"><span class="radio"></span>A. 正确</li>
                      <li :class="getReviewOptionClass(q, 'N')"><span class="radio"></span>B. 错误</li>
                    </template>
                    <template v-else>
                      <li v-for="(opt, oi) in q.options" :key="oi" :class="getReviewOptionClass(q, opt.alisa)">
                        <span class="radio"></span>{{ opt.alisa }}. <span v-html="opt.text"></span>
                      </li>
                    </template>
                  </ul>
                  <div class="analysis-box">
                    <p class="label">解析</p>
                    <p class="answer">
                      正确答案：{{ q.type === 'JUDGMENT' ? (q.answer === 'Y' ? '正确' : '错误') : q.answer }}
                      &nbsp; 你的答案：{{ formatUserAnswer(q) }} {{ q.isCorrect ? '✓' : '✗' }}
                    </p>
                    <p class="detail" v-if="q.analysis"><span v-html="q.analysis"></span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="review-sidebar">
              <div class="review-card">
                <p class="card-title">答题卡</p>
                <div class="review-grid">
                  <span
                    v-for="(q, idx) in reviewFlatQuestions"
                    :key="idx"
                    class="num"
                    :class="{ correct: q.isCorrect, wrong: !q.isCorrect, current: idx === reviewCurrentIdx }"
                    @click="goReviewQuestion(idx)"
                  >{{ idx + 1 }}</span>
                </div>
                <div class="review-legend">
                  <span><span class="dot correct"></span> 正确</span>
                  <span><span class="dot wrong"></span> 错误</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <WrongModal :visible.sync="wrongVisible" :courseId="courseId" :paperId="paperId" @deleted="getSummary" />
    <FavModal :visible.sync="favVisible" :courseId="courseId" :paperId="paperId" @deleted="getSummary" />
  </div>
</template>

<script>
import { quesMap, sectionTitle as _sectionTitle } from "@/utils/enums";
import WrongModal from "./components/WrongModal.vue";
import FavModal from "./components/FavModal.vue";

export default {
  name: "freeStudyPaperResult",
  components: { WrongModal, FavModal },
  data() {
    return {
      paperId: '',
      courseId: '',
      paperInfo: {},
      summaryData: {
        practiceCount: 0,
        correctRate: 0,
        rateTrend: undefined,
        avgCorrectRate: 0,
        wrongCount: 0,
        favCount: 0,
      },
      trendList: [],
      recordList: [],
      quesMap,
      reviewVisible: false,
      reviewRecord: {},
      reviewSections: [],
      reviewCurrentIdx: 0,
      wrongVisible: false,
      favVisible: false,
      pageLoading: false,
    };
  },
  computed: {
    reviewFlatQuestions() {
      const list = [];
      this.reviewSections.forEach(s => { s.questions.forEach(q => list.push(q)); });
      return list;
    },
  },
  created() {
    this.paperId = this.$route.query.paperId;
    this.courseId = this.$route.query.courseId;
    if (!this.paperId || !this.courseId) {
      this.$message.warning('参数缺失，即将返回');
      this.$router.replace('/main/specialtyPlan');
      return;
    }
    this.getSummary();
    this.getTrend();
    this.getRecordList();
  },
  methods: {
    normalizedHeight(rate) {
      const maxRate = Math.max(...this.trendList.map(i => i.rate), 1);
      const minHeight = 10;
      const maxHeight = 120;
      return Math.max(minHeight, Math.round((rate / maxRate) * maxHeight));
    },
    getSummary() {
      this.pageLoading = true;
      this.$http.get('/student/pc/freeStudy/paperResultSummary', { paperId: this.paperId, courseId: this.courseId }).then(res => {
        this.paperInfo = res.paperInfo || {};
        this.summaryData = {
          practiceCount: res.practiceCount || 0,
          correctRate: res.correctRate || 0,
          rateTrend: res.rateTrend,
          avgCorrectRate: res.avgCorrectRate || 0,
          wrongCount: res.wrongCount || 0,
          favCount: res.favCount || 0,
        };
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    getTrend() {
      this.$http.get('/student/pc/freeStudy/paperResultTrend', { paperId: this.paperId, courseId: this.courseId }).then(res => {
        const list = res || [];
        const maxRate = Math.max(...list.map(i => i.rate), 0);
        this.trendList = list.map(item => ({
          ...item,
          isBest: item.rate === maxRate,
        }));
      });
    },
    getRecordList() {
      this.$http.get('/student/pc/freeStudy/paperRecordList', { paperId: this.paperId, courseId: this.courseId }).then(res => {
        this.recordList = res || [];
      });
    },
    goRedo() {
      this.$confirm('确定要开始重新练习吗？', '重新练习', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/startRedo', { paperId: this.paperId, courseId: this.courseId }).then(() => {
          this.$router.push({ path: '/main/freeStudyPaper', query: { paperId: this.paperId, courseId: this.courseId, mode: 'answer' } });
        });
      }).catch(() => {});
    },
    openReview(record) {
      this.reviewRecord = record;
      this.reviewCurrentIdx = 0;
      this.$http.get('/student/pc/freeStudy/paperRecordDetail', { recordId: record.id }).then(res => {
        const sections = res.sections || [];
        let globalIndex = 0;
        sections.forEach(section => {
          section.questions = (section.questions || []).map(q => {
            globalIndex++;
            return { ...q, globalIndex };
          });
        });
        this.reviewSections = sections;
        this.reviewVisible = true;
      });
    },
    deleteRecord(record, idx) {
      this.$confirm('确定要删除这条练习记录吗？此操作不可恢复。', '删除记录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/deleteRecord', { recordId: record.id }).then(() => {
          this.$message.success('删除成功');
          this.getRecordList();
          this.getSummary();
          this.getTrend();
        });
      }).catch(() => {});
    },
    sectionTitle(section, si) {
      return _sectionTitle(section, si);
    },
    getReviewOptionClass(q, val) {
      if (q.type === 'MULTIPLECHOICE') {
        const isAnswer = q.answer && q.answer.includes(val);
        const isUser = q.userAnswer && q.userAnswer.includes(val);
        if (isAnswer) return { correct: true };
        if (isUser && !isAnswer) return { wrong: true };
        return {};
      }
      if (val === q.answer) return { correct: true };
      if (val === q.userAnswer && val !== q.answer) return { wrong: true };
      return {};
    },
    formatUserAnswer(q) {
      if (q.type === 'JUDGMENT') {
        return q.userAnswer === 'Y' ? '正确' : '错误';
      }
      if (Array.isArray(q.userAnswer)) return q.userAnswer.join('');
      return q.userAnswer || '';
    },
    goReviewQuestion(idx) {
      this.reviewCurrentIdx = idx;
      const q = this.reviewFlatQuestions[idx];
      if (q) {
        const ref = this.$refs['reviewQ_' + q.globalIndex];
        const el = ref && (Array.isArray(ref) ? ref[0] : ref);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    openWrongModal() {
      this.wrongVisible = true;
    },
    openFavModal() {
      this.favVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.free-study-page { min-height: 639px; }
.content-wrap {
  width: 100%;
  overflow: hidden;
  .mianbao { font-size: 14px; margin-bottom: 10px; }
}
.paper-summary {
  background: #fff; border-radius: 10px; margin-bottom: 16px; border: 1px solid #e3e3e3; overflow: hidden;
  .summary-top {
    background: $primary-light; padding: 20px 24px; border-bottom: 1px solid $primary-border;
    display: flex; justify-content: space-between; align-items: center;
    .paper-name { font-size: 18px; font-weight: bold; color: #333; margin-bottom: 10px; }
    .paper-meta { font-size: 13px; color: #666; display: flex; gap: 30px; }
  }
  .redo-btn {
    display: inline-flex; align-items: center; padding: 6px 16px; border-radius: 16px;
    background: #fff; color: $primary-dark; font-size: 13px; border: 1px solid $primary-dark;
    cursor: pointer; text-decoration: none; transition: all .2s;
    &:hover { background: $primary-light; }
  }
}
.summary-stats {
  display: flex; gap: 24px; padding: 16px 24px; align-items: flex-start;
  .stat-item {
    flex: 1; text-align: center; display: flex; flex-direction: column; align-items: center;justify-content: center;min-height: 90px;position: relative;
    .stat-num { font-size: 28px; font-weight: bold; color: $primary-dark; line-height: 1.2; }
    .stat-num.success { color: #67c23a; }
    .stat-num.warning { color: $accent; }
    .stat-num.danger { color: #f56c6c; }
    .stat-label { font-size: 13px; color: #999; margin-top: 4px; white-space: nowrap; }
    .stat-trend { font-size: 12px; margin-top: 4px; }
    .stat-trend.up { color: #67c23a;position: absolute;bottom: -5px;left: 50%;transform: translateX(-50%);}
    .stat-trend.down { color: #f56c6c; }
    &.clickable {
      cursor: pointer; border-radius: 8px; padding: 12px 8px; transition: background .2s;
      &:hover { background: #fef0f0; box-shadow: 0 2px 8px rgba(245,108,108,.15); }
      .stat-label { text-decoration: underline; text-decoration-style: dashed; text-underline-offset: 3px; }
    }
  }
}
.trend-card {
  background: #fff; border-radius: 10px; padding: 20px 24px; margin-bottom: 16px; border: 1px solid #e3e3e3;
  .card-title {
    font-size: 15px; font-weight: bold; color: #333; margin: -20px -24px 16px; padding: 14px 24px;
    background: $primary-light; border-bottom: 1px solid $primary-border;
    .sub { font-size: 12px; color: #999; font-weight: normal; margin-left: 8px; }
  }
}
.trend-chart {
  height: 170px; display: flex; align-items: flex-end; padding: 30px 20px 0; position: relative; gap: 16px; overflow: visible;
  &::before { content: ''; position: absolute; left: 0; right: 0; bottom: 60px; border-top: 1px dashed #eee; }
  &::-webkit-scrollbar { height: 6px; }
  &::-webkit-scrollbar-thumb { background: #c0c4cc; border-radius: 3px; }
  &::-webkit-scrollbar-track { background: #f0f0f0; border-radius: 3px; }
}
.trend-bar-wrap { display: flex; flex-direction: column; align-items: center; flex: 1 0 60px; }
.trend-bar {
  width: 40px; background: linear-gradient(180deg, $primary-dark 0%, $primary 100%); border-radius: 4px 4px 0 0;
  position: relative; transition: all .2s;
  &:hover { background: linear-gradient(180deg, $primary 0%, lighten($primary, 5%) 100%); transform: scaleY(1.02); transform-origin: bottom; }
  .bar-tooltip {
    position: absolute; top: -30px; left: 50%; transform: translateX(-50%);
    background: #333; color: #fff; padding: 4px 8px; border-radius: 4px; font-size: 12px; white-space: nowrap; opacity: 0; transition: opacity .2s; z-index: 10;
  }
  &:hover .bar-tooltip { opacity: 1; }
}
.trend-bar-wrap.best .trend-bar { background: linear-gradient(180deg, #67c23a 0%, #85ce61 100%); }
.trend-bar-label { margin-top: 8px; font-size: 12px; color: #999; }
.trend-legend {
  display: flex; justify-content: center; gap: 30px; margin-top: 16px; font-size: 12px; color: #999;
  span { display: flex; align-items: center; gap: 6px; }
  .dot { width: 12px; height: 12px; border-radius: 3px; }
  .dot.best { background: #67c23a; }
  .dot.normal { background: $primary-dark; }
}
.record-list-card {
  background: #fff; border-radius: 10px; border: 1px solid #e3e3e3;
  .record-list-header {
    padding: 14px 24px; background: $primary-light; border-bottom: 1px solid $primary-border;
    .title { font-size: 15px; font-weight: bold; color: #333; }
    .subtitle { font-size: 12px; color: #999; margin-top: 4px; }
  }
}
.record-item {
  display: table; width: 100%; table-layout: fixed; padding: 14px 24px; border-bottom: 1px solid #f5f5f5;
  transition: background .2s; cursor: pointer;
  &:last-child { border-bottom: none; }
  &:hover { background: #fafafa; }
  & > div { display: table-cell; vertical-align: middle; }
  .record-time {
    width: 130px;
    .time-date { font-size: 14px; color: #333; font-weight: bold; }
    .time-hour { font-size: 12px; color: #999; margin-top: 2px; }
  }
  .record-detail {
    font-size: 13px; color: #666;
    span { margin-right: 16px; }
    .val { font-weight: bold; }
    .val.correct { color: #67c23a; }
    .val.wrong { color: #f56c6c; }
  }
  .record-action {
    width: 160px; text-align: right; white-space: nowrap;
    .action-btn {
      display: inline-flex; align-items: center; padding: 6px 16px; border-radius: 16px;
      background: #fff; color: $primary-dark; font-size: 13px; border: 1px solid $primary-dark; cursor: pointer; transition: all .2s;
      &:hover { background: $primary-light; }
      &.delete { border-color: #f56c6c; color: #f56c6c; margin-left: 8px; }
      &.delete:hover { background: #fef0f0; }
    }
  }
}
.empty-state { text-align: center; padding: 60px 0; color: #999; font-size: 14px; .icon { font-size: 48px; margin-bottom: 16px; color: #ddd; } }
.review-stats {
  display: flex; gap: 20px; margin-bottom: 20px;
  .review-stat {
    flex: 1; padding: 16px; background: #f9f9f9; border-radius: 8px; text-align: center;
    .stat-value { font-size: 24px; font-weight: bold; color: $primary-dark; }
    .stat-value.correct { color: #67c23a; }
    .stat-value.wrong { color: #f56c6c; }
    .stat-label { font-size: 12px; color: #999; margin-top: 4px; }
  }
}
.review-questions { display: flex; gap: 16px; }
.review-main { flex: 1; }
.review-sidebar { width: 200px; flex-shrink: 0; }
.review-card {
  background: #fff; border-radius: 10px; padding: 16px; border: 1px solid #e3e3e3;
  .card-title { font-size: 14px; font-weight: bold; color: #333; margin-bottom: 12px; }
}
.review-grid {
  display: grid; grid-template-columns: repeat(5, 1fr); gap: 6px;
  .num {
    width: 24px; height: 24px; border-radius: 4px; display: flex; align-items: center; justify-content: center;
    font-size: 11px; cursor: pointer; transition: all .2s;
    &.correct { background: #f0f9eb; color: #67c23a; border: 1px solid #67c23a; }
    &.wrong { background: #fef0f0; color: #f56c6c; border: 1px solid #f56c6c; }
    &.current { box-shadow: 0 0 0 2px $primary-dark; }
  }
}
.review-legend {
  display: flex; gap: 12px; margin-top: 12px; font-size: 11px; color: #999; justify-content: center;
  span { display: flex; align-items: center; gap: 4px; }
  .dot { width: 12px; height: 12px; border-radius: 3px; }
  .dot.correct { background: #f0f9eb; border: 1px solid #67c23a; }
  .dot.wrong { background: #fef0f0; border: 1px solid #f56c6c; }
}
.question-card {
  background: #fff; border-radius: 10px; padding: 16px; border: 1px solid #e3e3e3; margin-bottom: 16px;
}
.q-section-title { font-size: 14px; font-weight: bold; color: #333; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 1px solid #f2f2f2; }
.q-item { margin-bottom: 24px; padding-bottom: 20px; border-bottom: 1px dashed #eee; &:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; } }
.q-num-tag { font-size: 14px; color: #333; font-weight: bold; margin-bottom: 10px; line-height: 1.6; }
.q-options {
  list-style: none; padding: 0;
  li {
    padding: 8px 14px; margin-bottom: 6px; border-radius: 6px; border: 1px solid #e3e3e3;
    font-size: 14px; display: flex; align-items: center; gap: 8px;
    .radio { width: 16px; height: 16px; border-radius: 50%; border: 2px solid #ccc; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
    &.correct { border-color: #67c23a; background: #f0f9eb; .radio { border-color: #67c23a; background: #67c23a; &::after { content: '\2713'; color: #fff; font-size: 10px; line-height: 1; } } }
    &.wrong { border-color: #f56c6c; background: #fef0f0; .radio { border-color: #f56c6c; &::after { content: '\2717'; color: #f56c6c; font-size: 10px; line-height: 1; } } }
  }
}
.analysis-box {
  background: #f9f9f9; border-radius: 8px; padding: 14px 18px; margin-top: 12px; border-left: 3px solid $primary-dark;
  .label { font-size: 13px; color: $primary-dark; font-weight: bold; margin-bottom: 6px; }
  .answer { font-size: 13px; color: #333; margin-bottom: 4px; }
  .detail { font-size: 13px; color: #666; line-height: 1.8; }
}
// 自定义弹窗通用样式
.custom-modal-mask {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.5);
  z-index: 2000; display: flex; align-items: flex-start; justify-content: center; padding-top: 8vh;
  overflow-y: auto;
}
.custom-modal {
  background: #fff; border-radius: 10px; border: 1px solid #e3e3e3; box-shadow: 0 4px 20px rgba(0,0,0,.15);
  max-height: 84vh; display: flex; flex-direction: column;
}
.custom-modal-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 24px; background: $primary-light; border-bottom: 1px solid $primary-border; border-radius: 10px 10px 0 0; flex-shrink: 0;
  .modal-title { font-size: 15px; font-weight: bold; color: #333; }
  .count { font-size: 13px; font-weight: normal; color: #999; margin-left: 8px; }
}
.custom-modal-close {
  font-size: 22px; color: #999; cursor: pointer; line-height: 1; padding: 0 4px;
  &:hover { color: #333; }
}
.custom-modal-body {
  flex: 1; overflow-y: auto; padding: 20px 24px;
}
</style>
